// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageTabs_wrapper__37apK"};